import {Component, EventEmitter, Input, OnChanges, Output, ViewChild} from '@angular/core';
import {factory} from '../../../shared/app-logging';
import {TemplateComponent} from '@/app/model/template-component';
import {Template} from '@/app/model/template';
import { ModalDirective } from 'ngx-bootstrap/modal';

const logger = factory.getLogger('SharedTemplatesModalComponent');

@Component({
  selector: 'app-shared-templates-modal',
  templateUrl: './shared-templates-modal.component.html',
  styleUrls: ['./shared-templates-modal.component.scss']
})
export class SharedTemplatesModalComponent implements OnChanges {

  @ViewChild('sharedTemplatesModal', {static: true})
  sharedTemplatesModal: ModalDirective;

  @Input() templateComponent: TemplateComponent;
  @Input() sharedTemplates: Array<Template>;
  @Input() templatesTotalCount: number;

  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  displayedColumns: string[] = ['template', 'productLine'];

  constructor() { }

  ngOnChanges(changes: any): void {
    if (changes.templateComponent?.currentValue || (changes.sharedTemplates?.currentValue && changes.sharedTemplates?.currentValue.length > 0)) {
      changes.sharedTemplates?.currentValue.sort((a, b) => {
        if (a.displayLabel > b.displayLabel) {
          return 1;
        }
        if (a.displayLabel < b.displayLabel) {
          return -1;
        }
        return 0;
      });
      this.sharedTemplatesModal.show();
    }
  }

  closeModal() {
    this.sharedTemplatesModal.hide();
    this.close.emit(true);
  }

}
